export default __webpack_public_path__ + "media/images/icons/certified-dekra-75c3fc8d7a92bd21fe64e8e971c33a7e.svg";